Controller.$inject = [];

function Controller() {

}

export function HuiPageBody() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            layout: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `<div class="hui hui-page-body">
                       <div class="header-shadow"></div>
                       <div class="hui-page-body-wrapper" 
                            ng-class="[$huiCtrl.layout || 'fixed']">
                          <ng-transclude/>
                    </div>
                    `;
        }
    };
}